import { Box, Text } from '@chakra-ui/react';
import { camelCase } from 'lodash';

import { IHighlightMultiCard } from '../MediaPackDetailHighlightCard.types';

type Props = Omit<
  IHighlightMultiCard,
  'title' | 'description' | 'isMulti' | 'metricKey'
>;

export const MediaPackDetailHighlightCardMultiValues: React.FC<Props> = ({
  transformValue: defaultTransfromValue,
  values,
  lastUpdated,
}) => (
  <>
    {values.map(({ title, value, transformValue = defaultTransfromValue }) => (
      <Box key={`${camelCase(title)}-${value}`}>
        <Text
          display="inline"
          marginRight={3}
          fontSize="xl"
          fontWeight="medium"
        >
          {transformValue ? transformValue(value, 'n/a') : value}
        </Text>
        <Text display="inline" color="neutral.400" fontSize="md">
          {title}
        </Text>
        <Text color={'primary.400'} fontSize="sm" fontWeight={400}>
          {lastUpdated}
        </Text>
      </Box>
    ))}
  </>
);
